export const faqData = [
  {
    question: 'Where do we plan on building the Community Center and School?',
    answer: 'West of the Church, as shown on the site plan below.',
    image: '/images/faq-siteplan.png',
    imageAlt: 'Site plan showing the Community Center location west of the Church',
    imageCaption: 'Site Plan — Community Center and School, April 2026',
  },
  {
    question: 'Why was this location chosen?',
    answerIntro: 'Multiple reasons, including:',
    answerList: [
      'Increased lot density for future projects and expansions',
      'Prior Conditional Use Permit simplifies pre-construction',
      'Minimizes construction costs by avoiding Redmond-Woodinville Road improvements',
      'Simplifies Church sewer line connections',
      'Avoids disruption to ongoing school activities',
    ],
  },
  {
    question: 'Do we plan to expand the Parking Lot?',
    answer:
      'Yes. Approximately 60 additional parking spots are planned as a high priority.',
  },
  {
    question: 'Is the Community Center going to be suitable for concerts?',
    answer:
      'Yes. The top floor hall will include a stage for concerts and can accommodate up to 250 guests.',
  },
  {
    question:
      'How long is it expected to take to build the Community Center and School?',
    answer:
      'If there are no delays, the end-to-end project will require at least approximately 2 years. The first year is for producing all pre-construction documentation and obtaining permits; the second year is the construction itself.',
  },
  {
    question: 'How much is the project expected to cost?',
    answer:
      'Accurate estimates will be available after detailed design finalization. Rough estimates suggest between $2,500,000 and $3,000,000.',
  },
  {
    question: 'Do we have sufficient funds for this project?',
    answer:
      'No. To fund this project we will need wide participation of our community AND securing a construction loan. Rough estimates indicate participation from approximately 150 families contributing at least $100 monthly throughout the project duration, in addition to existing School and Church support.',
  },
];
